import API_URLS from '../links';

export const loginAdmin = (creds) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.LOGIN_ADMIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...creds, device_type: 0, device_token: '0' })
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const registerAdmin = (formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.REGISTER_ADMIN, {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const forgotPasswordAdmin = (data) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.FORGOT_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getRecords = (creds, gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_RECORDS + `/${gymId}`, {
        method: 'GET',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getQueries = (creds, gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_QUERIES + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getEarnings = (creds) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_EARNINGS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getfollowUpsQueries = (creds, gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_QUERIES_FOLLOWUPS + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getDashboardData = (creds, gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_DASHBOARD_DATA + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addQuery = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_QUERY, {
        method: 'POST',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const completeOrRescheduleQuery = (creds, data) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.COMPLETE_OR_RESCHEDULE_QUERY, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: JSON.stringify(data)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const completeOrReschedulePayment = (creds, data) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.COMPLETE_OR_RESCHEDULE_PAYMENT, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: JSON.stringify(data)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const changePasswordAPI = (creds, values) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.CHANGE_PASSWORD, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        },
        body: JSON.stringify({
          old_password: values.oldPassword,
          new_password: values.newPassword
        })
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateAdminProfiledAPI = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_PROFILE, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteAdmin = (creds, values) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_ADMIN, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
